/**
 *@author yudeping
 *子表控件
 */


import Component from '../../../lib/component'
import DataTableAgGrid from '../../dataGrid/data-table-page/data-table-agGrid/data-table-agGrid';
import './songridControl.scss'
import template from './songrid-control.html';
import Mediator from '../../../lib/mediator';
import WXtemplate from './songrid-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';
import {HTTP,returnIframeUrl} from "../../../lib/http";
import msgBox from '../../../lib/msgbox'

let config={
    template:template,
    actions:{
      songridDefault(res){
          if(res == _this.data.value){
              dataGrid.actions.getGridData();
          }
      },
	    init(){
      	setTimeout(()=> {
            window.top.config.menu.forEach((item)=> {
                item.items.forEach((data)=>{
                    if(data.table_id.indexOf(this.data.value) != -1) {
                       this.data.tableName = data.label
                    }
                })
            })
            this.data.isInit=true;
            let config={
                tableId:this.data.value,
                parentTableId:this.data.parent_table_id,
                rowId:this.data.parent_temp_id || '',
                record_id:this.data.recordId || '',
                parentRealId:this.data.parent_real_id || '',
                parentRecordId:this.data.recordId || '',
                parentTempId:this.data.parent_temp_id || '',
                tableType:'child',
                viewMode:this.data.is_view==0?'EditChild':'ViewChild',
                formData: this.data.formData,
                fromApprove: this.data.fromApprove,
                parent_btnType: window.config.btnType,
                form_songrid: 1,
                isFromForm: 1,
                tableName:this.data.tableName,
	            flowId:this.data.flowId,
                flowIndex:this.data.index,
            };
            /**
             * 新增编辑的子表、没有入库工作流请求数据需要传is_temp=1参数，同时filter搜索中section_page_[parent_table_id]应该为parent_temp_id，查看时为parent_real_id
             * 因此做了下边的判断：
             * window.config.in_process == 1是数据在途的判断
             * window.config['end_state']是还在流程中的判定
             * window.config.btnType == 'new'||'edit'是发起编辑表单的判定
             * window.config['newWorkflow'] == 1是发起新工作的判定
             * window.config.songridFromProcess == 1是编辑子表的子表的判定
             * 以上都是去temp库查数据的情况（如果有问题在修改）
             */
            if(window.config.in_process == 1||window.config['end_state'] == 0||window.config.btnType == 'new'
                ||window.config.btnType == 'edit'||window.config['newWorkflow'] == 1||window.config.songridFromProcess==1){
                config['songridFromProcess'] = 1;
            }
            /**
             * window.config['view_finish_data']是数据穿透时需要的参数
             */
            if(window.config['view_finish_data'] == 1){
                config['finishWork'] = 1;
            }
            /**
             * 判断是已完成的工作页面查看工作流里面的字表
             * 以及从消息提醒里面打开的已完成的工作
             * 添加songridFromProcess=1属性
             */
            if(window.config['end_state'] == 1&&this.data.recordId){
                config['songridFromProcess'] = 1;
                config['fromApprove'] = 1;
            }
            //判断字表查看表单需不需要转编辑按钮用
            if(window.location.href.indexOf('btnType=view' !=-1)){
                config['parent_btnType'] = 'none';
            }
            if(this.data.isInprocessFilter){
            	config.isInprocessFilter=this.data.isInprocessFilter;
            }
            this.data['sonGridConfig'] = config;
            if(this.el.find('.songGrid').length!=0){
                this.dataGrid && this.dataGrid._destroy();
                this.dataGrid=new DataTableAgGrid({data: config});
                this.append(this.dataGrid,this.el.find('.songGrid'));
            }
            this.hideLoading();
		},0)
	    }
    },
    binds:[
        {
            event: 'click',
            selector: '.ui-forms-a',
            callback: function(){
            	let url = returnIframeUrl('/iframe/sourceDataGrid/',this.data['sonGridConfig'])
                this.events.openSongGrid(this.data,url)
            }
        },
        {
            event: 'click',
            selector: '.add-item',
            callback: function(){
                this.events.addItem(this.data)
            }
        }
    ],
    afterRender(){
      this.showLoading();
	  this.actions.init();
    },
	firstAfterRender(){
        let notice='form:songGridRefresh:'+this.data["value"];
        if(this.data.index || this.data.index==0){
            notice=notice+this.data.index;
        }
		Mediator.subscribe(notice,(res)=>{
			if(res && this.data &&  res.tableId == this.data["value"]){
				this.data["total"] = res.total;
				if (this.data.total == 0) {
					this.el.find('#requiredLogo').removeClass().addClass('required');
				}else {
					this.el.find('#requiredLogo').removeClass().addClass('required2');
				}
				this.events.emitDataIfInline(this.data);
				this.data.isInit=false;
			}
		})
	},
    beforeDestory(){
        this.el.off();
    }
};
let Songrid = Component.extend(config)
export default Songrid;

let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		init(){
			this.data.isInit=true;
			let config={
				tableId:this.data.value,
				parentTableId:this.data.parent_table_id,
				rowId:this.data.parent_temp_id || '',
				record_id:this.data.recordId || '',
				parentRealId:this.data.parent_real_id || '',
				parentRecordId:this.data.recordId || '',
				parentTempId:this.data.parent_temp_id || '',
				tableType:'child',
				viewMode:this.data.is_view==0?'EditChild':'ViewChild',
				formData: this.data.formData,
				fromApprove: this.data.fromApprove,
				parent_btnType: window.config.btnType,
				form_songrid: 1,
				wxOperate:true
			};
            if(window.config.in_process == 1||window.config['end_state'] == 0||window.config.btnType == 'new'||window.config['newWorkflow'] == 1){
                config['songridFromProcess'] = 1;
            }
            if(window.config['view_finish_data'] == 1){
                config['finishWork'] = 1;
            }
			if(window.location.href.indexOf('btnType=view' !=-1)){
				config['parent_btnType'] = 'none';
			}
			if(this.el.find('.songGrid').length!=0){
				this.dataGrid=new DataTableAgGrid({data: config});
				this.append(this.dataGrid,this.el.find('.songGrid'));
			}
			this.el.closest('.wxControl-wrap').css('background-color','rgba(255,255,255,.9)')
		}
	}),
	afterRender(){
		this._super.afterRender();
		this.actions.init();
	},
	beforeDestory:config.beforeDestory,
}
let SongridWX=BaseControl.extend(WXconfig);
export {SongridWX}


// WEBPACK FOOTER //
// app/components/form/songrid-control/songrid-control.js